<template>
  <f7-card class="private-gym-card card-raised">
    <f7-card-content>
      <div v-html="safeNotes" class="mb-4"></div>
      <div v-for="comment in user.comments">
        <div class="row mb-3">
          <div class="col-12">
            <div class="text-black-50">
              {{ comment.commenter.first_name }} {{ comment.commenter.last_name }} @{{ comment.created_at }}
            </div>
          </div>
          <div class="col-12">
            {{ comment.content }}
          </div>
        </div>
      </div>
      <hr/>
      <f7-list class="list-strong list-outline list-dividers">
        <f7-list-input label="Nieuwe notitie" type="textarea" placeholder="..."
                       v-model:value="newNote"
        >
        </f7-list-input>
      </f7-list>
    </f7-card-content>
    <f7-card-footer class="no-border">
      <div></div>
      <f7-button tonal @click="storeNote">Opslaan</f7-button>
    </f7-card-footer>
  </f7-card>
</template>

<script>

  import { sanitiseNotesHtml } from '../../../js/sanitise';

  export default {
    components: {},

    props: [
        'user',
    ],

    mixins: [],

    data: function () {
      return {
        newNote: '',
      };
    },

    computed: {
      /**
       * `users.notes` is the only value in this component rendered with
       * `v-html`, so it is the only one that needs sanitising.
       *
       * `comment.content` on line ~15 is deliberately left alone: it is rendered
       * with `{{ }}`, which Vue already escapes. Sanitising it would have no
       * rendering consequence and would be actively wrong — `{{ }}` would then
       * display `&amp;` for any future `&`.
       *
       * A computed rather than an inline `sanitiseNotesHtml(user.notes)` call:
       * this component re-renders on every keystroke in the "Nieuwe notitie"
       * textarea, and an inline call would re-sanitise the notes each time.
       *
       * @returns {string}
       */
      safeNotes() {
        return sanitiseNotesHtml(this.user.notes);
      },
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      storeNote() {
        this.$store.commit('app/show_loader');
        this.$store.dispatch('api/postEndpoint', {
          endpoint: '/users/' + this.user.id + '/notes',
          data: {
            note: this.newNote,
          }
        }).then(response => {
          this.$emit('updateUser', response.data.data);
          this.newNote = '';
        })
        .finally(() => {
          this.$store.commit('app/hide_loader');
        })
      },
    },

    watch: {
      //
    }
  };
</script>
